import React, { useState } from 'react';
import { gql, useMutation } from '@apollo/client';
import { useAppState, ActionType } from '../state/AppState';
import { Button } from 'antd';
import HomeButton from './common/HomeButton';
import { useParams } from 'react-router-dom';
import Form from 'antd/lib/form/Form';
import SelectAV from './SelectAV';
import ChooseAvatar from './ChooseAvatar';
import EditUserNameAvatar from './EditUserNameAvatar';

const EDIT_USER_PROPERTIES = gql`
  mutation EditAnonUserFields(
    $displayName: String!
    $partyKey: String
    $hasAcceptedProfile: Boolean
    $avatarFileUpload: String
  ) {
    updateUser(
      userInput: {
        displayName: $displayName
        partyKey: $partyKey
        hasAcceptedProfile: $hasAcceptedProfile
        avatarFileUpload: $avatarFileUpload
      }
    ) {
      user {
        displayName
        hasAcceptedProfile
        avatarUrl
      }
    }
  }
`;

enum OnboardingStep {
  Main,
  SelectAV,
  ChooseAvatar,
}

const OnboardAnonymousUser = () => {
  const { user, dispatch } = useAppState();
  const { partyKey } = useParams<{ partyKey: string }>();
  const [nameValue, setNameValue] = useState<string>('');
  const [tempAvatar, setTempAvatar] = useState<string | null>(null);
  const [updateUserInfo] = useMutation(EDIT_USER_PROPERTIES);
  const [onboardingStep, setOnboardingStep] = useState<OnboardingStep>(OnboardingStep.Main);

  const onSubmit = async () => {
    const resp = await updateUserInfo({
      variables: {
        displayName: nameValue,
        partyKey: (partyKey || '').toLowerCase(),
        hasAcceptedProfile: true,
        avatarFileUpload: tempAvatar,
      },
    });
    const user = resp.data.updateUser.user;
    await dispatch({
      type: ActionType.UpdateUser,
      user,
    });
  };

  return (
    <div className='onboarding-container'>
      <HomeButton />
      <div className='onboarding-card'>
        {onboardingStep === OnboardingStep.SelectAV && (
          <SelectAV onComplete={() => setOnboardingStep(OnboardingStep.Main)} />
        )}
        {onboardingStep === OnboardingStep.Main && (
          <>
            <Form layout='vertical' onSubmitCapture={() => onSubmit()}>
              <EditUserNameAvatar
                nameValue={nameValue}
                tempAvatar={tempAvatar}
                onNameChange={(name) => setNameValue(name)}
              />
              <div className='onboarding-actions-group' style={{ marginTop: 20, marginBottom: 20 }}>
                {/* disabled for now because we don't have the publisher mounter yet */}
                {/* <Button
                  style={{ width: '48%', height: 80 }}
                  size='large'
                  onClick={async () => {
                    await dispatch({
                      type: ActionType.ToggleAV,
                      enabled: true,
                    });
                    setOnboardingStep(OnboardingStep.SelectAV);
                  }}>
                  turn on
                  <br />
                  your camera
                </Button> */}
                <Button
                  style={{ width: '100%', height: 60 }}
                  size='large'
                  onClick={() => {
                    setOnboardingStep(OnboardingStep.ChooseAvatar);
                  }}>
                  choose a
                  <br />
                  new avatar
                </Button>
              </div>
              <div className='onboarding-actions-group'>
                <Button
                  type='primary'
                  htmlType='submit'
                  className='cta'
                  style={{ width: '100%', height: 80, border: 'none' }}
                  size='large'>
                  enter the backroom
                </Button>
              </div>
            </Form>
          </>
        )}
        {onboardingStep === OnboardingStep.ChooseAvatar && (
          <ChooseAvatar
            onComplete={(base64String: string | null) => {
              setTempAvatar(base64String);
              setOnboardingStep(OnboardingStep.Main);
            }}
            onCancel={() => setOnboardingStep(OnboardingStep.Main)}
          />
        )}
      </div>
    </div>
  );
};

export default OnboardAnonymousUser;
